module.exports = __webpack_public_path__ + "static/marantec-3746fbe5d029a3db5ce222ef7e5a2ced.png";